import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Grid, GridItem } from '@chakra-ui/react';
import { useT } from '@progress-fe/core';
import { Input } from '../../inputs';
import { VirtualTable } from '../../tables';
import { IconButton } from '../../buttons';
const ReactionsListFC = ({ reactions, selectedReactions, onAddReaction, onDeleteReaction, tableSx }) => {
    const { t } = useT();
    const [query, setQuery] = useState('');
    const columns = [{ name: t('fields.name'), align: 'left' }];
    const filteredReactions = useMemo(() => reactions.filter((opt) => opt.name.toLowerCase().includes(query.toLowerCase())), [query, reactions]);
    const rows = useMemo(() => filteredReactions.map((opt) => ({
        key: opt.uuid,
        values: [opt.name],
        isSelected: selectedReactions.has(opt.uuid),
        isDisabled: false
    })), [filteredReactions, selectedReactions]);
    return (_jsxs(Grid, { templateRows: "auto 1fr", gap: "8px", children: [_jsx(GridItem, { children: _jsx(Input, { name: "search", size: "xs", variant: "outline", value: query, placeholder: t('actions.search'), onChange: setQuery, rightElement: query ? _jsx(IconButton, { icon: 'Cross', onClick: () => setQuery('') }) : undefined }) }), _jsx(VirtualTable, { rows: rows, isCheckboxShown: true, columns: columns, noItemsTitle: t('reactions.emptySearch'), tableSx: tableSx, onSelect: onAddReaction, onUnselect: onDeleteReaction })] }));
};
export const ReactionsList = observer(ReactionsListFC);
//# sourceMappingURL=ReactionsList.js.map